import { RoamingOption } from '../container/RoamingAdvisor/types';
import {
    createPromoPriceComponent,
    IPromoPriceProperties,
    PROMO_PRICE_SIZE_MEDIUM,
} from '@vfde-brix/promo-price';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const roamingOptionMarkup = require('../container/RoamingAdvisor/hbs/roaming-option.hbs');

/**
 * mountRoamingOption
 */
export const mountRoamingOption = (parentTargetID: string, data: RoamingOption) => {
    const parentDiv = document.getElementById(parentTargetID);
    const optionDiv = document.createElement('div');

    optionDiv.innerHTML = roamingOptionMarkup({ data });

    if (data.promoPrice) {
        const promoPriceData: IPromoPriceProperties = {
            price: {
                euro: data.promoPrice.price.euro,
                cent: data.promoPrice.price.cent,
            },

            stdAdditionalText: data.promoPrice.additionalText,

            optSizeVariation: PROMO_PRICE_SIZE_MEDIUM,
            optPriceCondition: data.promoPrice.priceCondition,
            business: NO_PATTERN_BUSINESS_LOGIC,
        };
        createPromoPriceComponent(optionDiv.querySelector('.sails-ra__promo-price'), promoPriceData);
    }

    parentDiv.appendChild(optionDiv);
};
